import { render, staticRenderFns } from "./QueuesView.vue?vue&type=template&id=647e435b&scoped=true&"
import script from "./QueuesView.vue?vue&type=script&lang=js&"
export * from "./QueuesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647e435b",
  null
  
)

export default component.exports